export const EDIT_ICON = `
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M14 4.87476C14.6212 4.87476 15.1249 5.37855 15.125 5.99976C15.125 6.62108 14.6213 7.12476 14 7.12476H7.5C7.29297 7.12476 7.12512 7.29276 7.125 7.49976V24.4998C7.125 24.7069 7.29289 24.8748 7.5 24.8748H24.5C24.7071 24.8748 24.875 24.7069 24.875 24.4998V17.9998C24.8751 17.3785 25.3788 16.8748 26 16.8748C26.6212 16.8748 27.1249 17.3785 27.125 17.9998V24.4998C27.125 25.9495 25.9497 27.1248 24.5 27.1248H7.5C6.05025 27.1248 4.875 25.9495 4.875 24.4998V7.49976C4.87512 6.05012 6.05033 4.87477 7.5 4.87476H14Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.8467 4.1189C23.0671 2.89852 25.0457 2.89852 26.2661 4.1189L27.6802 5.53297C28.9006 6.75336 28.9006 8.73201 27.6802 9.9524L16.3667 21.2659C16.1946 21.4379 15.9713 21.5498 15.7305 21.5842L10.7808 22.2913C10.4302 22.3413 10.0761 22.2233 9.82568 21.9729C9.57544 21.7225 9.45775 21.3688 9.50781 21.0183L10.2148 16.0686C10.2493 15.8277 10.3611 15.6045 10.5332 15.4324L21.8467 4.1189ZM12.3892 16.7581L11.9473 19.8518L15.041 19.4099L23.5552 10.8958L20.9033 8.2439L12.3892 16.7581ZM24.6753 5.70972C24.3336 5.36802 23.7792 5.36802 23.4375 5.70972L22.4941 6.65308L25.146 9.30494L26.0894 8.36158C26.4311 8.01987 26.4311 7.4655 26.0894 7.12379L24.6753 5.70972Z"
      fill="currentColor"
    />
  </svg>
`;
